import { Router } from '@angular/router';
import { oldRouters } from 'src/app/main/shared/old-routers';

/**
 * Goes to a global search result. Shared by the classic toolbar and the Steel header so both
 * resolve results the same way.
 */
export function navigateToSearchResult(router: Router, item: any): void {
  // Older results name a legacy router state; map it for backward compatibility.
  const foundRouter = oldRouters.find((r) => r.state === item.sref);
  if (foundRouter) {
    if (foundRouter.isDetail) {
      router.navigate([foundRouter.url, item.entityId]);
    } else {
      router.navigate([foundRouter.url]);
    }
  } else if (item.url) {
    // System views (Entity = "View") don't take an entityId.
    if (item.entityId && item.entity !== 'View') {
      router.navigate([item.url, item.entityId]);
    } else {
      router.navigate([item.url]);
    }
  } else {
    console.log('No navigation path found for search item:', item);
  }
}
